import { PageId } from 'constants/pages'

export const enum PageIdStylioCapsuleIo {
  AGE_CAPSULE_IO = PageId.AGE_CAPSULE_IO,
  URGE_CAPSULE_IO = PageId.URGE_CAPSULE_IO,
  HAIR_COLOR_CAPSULE_IO = PageId.HAIR_COLOR_CAPSULE_IO,
  EYES_COLOR_CAPSULE_IO = PageId.EYES_COLOR_CAPSULE_IO,
  JEWELRY_CAPSULE_IO = PageId.JEWELRY_CAPSULE_IO,
  BODY_SHAPE_CAPSULE_IO = PageId.BODY_SHAPE_CAPSULE_IO,
  OUTFIT_STRUGGLES_CAPSULE_IO = PageId.OUTFIT_STRUGGLES_CAPSULE_IO,
  STYLIO_TO_HELP_CAPSULE_IO = PageId.STYLIO_TO_HELP_CAPSULE_IO,
  TALL_CAPSULE_IO = PageId.TALL_CAPSULE_IO,
  WEIGHT_CAPSULE_IO = PageId.WEIGHT_CAPSULE_IO,
  BODY_COMFORT_CAPSULE_IO = PageId.BODY_COMFORT_CAPSULE_IO,
  WHAT_YOU_WEAR_CAPSULE_IO = PageId.WHAT_YOU_WEAR_CAPSULE_IO,
  URGE_2_CAPSULE_IO = PageId.URGE_2_CAPSULE_IO,
  SHOPPING_CAPSULE_IO = PageId.SHOPPING_CAPSULE_IO,
  STYLE_MOST_MATTERS_CAPSULE_IO = PageId.STYLE_MOST_MATTERS_CAPSULE_IO,
  YOUR_LOCATION_CAPSULE_IO = PageId.YOUR_LOCATION_CAPSULE_IO,
  FEEL_ABOUT_CAPSULE_IO = PageId.FEEL_ABOUT_CAPSULE_IO,
  WARDROBE_USAGE_CAPSULE_IO = PageId.WARDROBE_USAGE_CAPSULE_IO,
  NOT_ALONE_CAPSULE_IO = PageId.NOT_ALONE_CAPSULE_IO,
  PERCENTAGE_CAPSULE_IO = PageId.PERCENTAGE_CAPSULE_IO,
  FAVORITE_COLORS_CAPSULE_IO = PageId.FAVORITE_COLORS_CAPSULE_IO,
  LIKE_OR_DISLIKE_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_CAPSULE_IO,
  LIKE_OR_DISLIKE_11_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_11_CAPSULE_IO,
  LIKE_OR_DISLIKE_12_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_12_CAPSULE_IO,
  LIKE_OR_DISLIKE_13_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_13_CAPSULE_IO,
  LIKE_OR_DISLIKE_14_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_14_CAPSULE_IO,
  LIKE_OR_DISLIKE_15_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_15_CAPSULE_IO,
  LIKE_OR_DISLIKE_16_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_16_CAPSULE_IO,
  LIKE_OR_DISLIKE_17_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_17_CAPSULE_IO,
  LIKE_OR_DISLIKE_18_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_18_CAPSULE_IO,
  LIKE_OR_DISLIKE_19_CAPSULE_IO = PageId.LIKE_OR_DISLIKE_19_CAPSULE_IO,
  SEE_YOURSELF_CAPSULE_IO = PageId.SEE_YOURSELF_CAPSULE_IO,
  STYLES_FEEL_LIKE_YOU_CAPSULE_IO = PageId.STYLES_FEEL_LIKE_YOU_CAPSULE_IO,
  URGE_4_CAPSULE_IO = PageId.URGE_4_CAPSULE_IO,
  WHAT_YOU_WILL_FIND_CAPSULE_IO = PageId.WHAT_YOU_WILL_FIND_CAPSULE_IO,
  BRAND_CAPSULE_IO = PageId.BRAND_CAPSULE_IO,
  FIND_NEW_CLOTHES_CAPSULE_IO = PageId.FIND_NEW_CLOTHES_CAPSULE_IO,
  NOTHING_TO_WEAR_CAPSULE_IO = PageId.NOTHING_TO_WEAR_CAPSULE_IO,
  OLD_CLOTHES_CAPSULE_IO = PageId.OLD_CLOTHES_CAPSULE_IO,
  COMBINE_CLOTHES_CAPSULE_IO = PageId.COMBINE_CLOTHES_CAPSULE_IO,
  OPTIMIZE_BUDGET_CAPSULE_IO = PageId.OPTIMIZE_BUDGET_CAPSULE_IO,
  URGE_3_CAPSULE_IO = PageId.URGE_3_CAPSULE_IO,
  PREPARE_FLOW_CAPSULE_IO = PageId.PREPARE_FLOW_CAPSULE_IO,
  EMAIL_CAPSULE_IO = PageId.EMAIL_CAPSULE_IO,
  EMAIL_CONSENT_CAPSULE_IO = PageId.EMAIL_CONSENT_CAPSULE_IO,
  SUBSCRIPTIONS_CAPSULE_IO = PageId.SUBSCRIPTIONS_CAPSULE_IO,
  CANCEL_OFFER_CAPSULE_IO = PageId.CANCEL_OFFER_CAPSULE_IO,
  AI_STYLIST_UPSELL_CAPSULE_IO = PageId.AI_STYLIST_UPSELL_CAPSULE_IO,
  SUB_UPSELL_CAPSULE_IO = PageId.SUB_UPSELL_CAPSULE_IO,
  UPSELL_CAPSULE_IO = PageId.UPSELL_CAPSULE_IO,
  FACE_UPSELL_CAPSULE_IO = PageId.FACE_UPSELL_CAPSULE_IO,
  BUNDLE_UPSELL_CAPSULE_IO = PageId.BUNDLE_UPSELL_CAPSULE_IO,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPSULE_IO = PageId.DOWNLOAD_CAPSULE_IO,
}
